// TumHaberler.tsx
import React, { useEffect, useState } from "react";
import Layout from "../../components/yenimahalle/Layout";
import BasicHeader from "../../components/yenimahalle/BasicHeader";
import ListGrid from "components/yenimahalle/ListGrid";
import PortalApi from "api/PortalApi";
import { Announcement } from "models/Response/Portal";
import { dateFormatter } from "utils/dateFormatter";
import { CustomButton, CustomModal } from "albinasoft-ui-package";

interface NewsItem {
  title: string;
  date?: string;
  content?: string;
  rawDate?: Date; // Ham tarih bilgisi, sıralama için kullanılacak.
}

const Duyurular: React.FC = () => {
  const [newsItems, setNewsItems] = useState<NewsItem[]>([]);
  const [showDetail, setShowDetail] = useState<boolean>(false);
  const [selectedNews, setSelectedNews] = useState<NewsItem | null>(null);

  useEffect(() => {
    // API'den duyuru verilerini çekiyoruz
    const fetchData = async () => {
      const response = await PortalApi.getActiveAnnouncements();
      if (response && response.announcements) {
        const mappedItems: NewsItem[] = response.announcements.map(
          (item: Announcement) => ({
            title: item.header,
            date: dateFormatter(item.announcementDate, false),
            content: item.content, // Duyurunun içerik kısmı (HTML formatında)
            rawDate: new Date(item.announcementDate), // Sıralama için ham tarih
          })
        );

        // Mevcut tarihe (Date.now()) en yakın olan duyurunun ilk sıralarda gelmesi için sıralama:
        mappedItems.sort(
          (a, b) =>
            Math.abs((a.rawDate as Date).getTime() - Date.now()) -
            Math.abs((b.rawDate as Date).getTime() - Date.now())
        );

        setNewsItems(mappedItems);
      }
    };

    fetchData();
  }, []);

  return (
    <Layout>
      <BasicHeader
        headingLine1="Sosyal Belediyecilik Anlayışına Sahip Mutlu Bir İlçe"
        headingLine2=""
      />
      <ListGrid
        items={newsItems}
        showDateFilter={false}
        onFilterChange={() => {}}
        onItemClick={(item: NewsItem) => {
          // Duyuruya tıklandığında seçilen duyuruyu state'e atıyoruz
          setSelectedNews(item);
          // Modal görünür hale getiriliyor
          setShowDetail(true);
        }}
      />

      <CustomModal
        title={selectedNews ? selectedNews.title : "Duyuru Detayları"}
        show={showDetail}
        size="lg"
        onHide={() => setShowDetail(false)}
        footer={
          <CustomButton onClick={() => setShowDetail(false)} label="Kapat" />
        }
      >
        {selectedNews?.content ? (
          // HTML içeriği render etmek için dangerouslySetInnerHTML kullanıyoruz.
          <div dangerouslySetInnerHTML={{ __html: selectedNews.content }} />
        ) : (
          <p>İçerik bulunamadı.</p>
        )}
      </CustomModal>
    </Layout>
  );
};

export default Duyurular;
